import React, { useState } from "react";
import enterOtpBg from '../assets/images/verify-otp.jpg';
import PrimaryButton from "./inputs/PrimaryButton";
import OTPField from "./inputs/OTPField";
import Counter from "./Counter";
import { useAuth } from "../context/AuthContext";
import { Api } from "../api/Api";
import { getLogo, parseJwt } from "../helpers/Helpers";
import PatientSelection from "./PatientSelection";
import { showToast } from "../helpers/UIHelper";
import MRNSearch from "./MRNSearch";

const OTPEnter = (props) => {
    const [verifying, setVerifying] = useState(false);
    const [otpExpired, setOtpExpired] = useState(false);
    const Auth = useAuth();
    const [patients, setPatients] = useState([]);
    const [otp, setOtp] = useState('');
    const [isLoginLoading, setIsLoginLoading] = useState(false);
    const [showMrnSearch, setShowMrnSearch] = useState(false);
    const [responseData, setResponseData] = useState(null);
    const checkOTP = () => {
        setVerifying(true);
        Api.authenticateOTP(props.mobile.replaceAll('-', ''), otp).then((resp) => {
            if (resp.status === 200) {
                if (resp.data.error) {
                    showToast('error', 'Entered OTP is wrong, Or is expired. Please try again.')
                    setVerifying(false);
                    return;
                }
                const { accessToken } = resp.data;
                const data = parseJwt(accessToken);
                data.patients = resp.data.patients;
                if (resp.data.patients.length === 0) {
                    setResponseData(resp.data);
                    setShowMrnSearch(true);
                    setVerifying(false);
                    return;
                }
                const authenticatedUser = { data, accessToken };
                Auth.userLogin(authenticatedUser);
                if (resp.data.patients.length > 1) {
                    setPatients(resp.data.patients);
                    return;
                }
                if (!Auth.userIsAuthenticated()) {
                    showToast('error', 'Entered OTP is wrong, Or is expired. Please try again.');
                    setTimeout(() => { window.location.href = "/" }, 2000);
                } 
                setVerifying(false);
            } else {
                showToast('error', 'Entered OTP is wrong, Or is expired. Please try again.');
                setVerifying(false);
            }
        }).catch((e) => {
            setVerifying(false);
            showToast('error',e);
        });
    }
    const loginSelectedPatient = (patient) => {
        setIsLoginLoading(true);
        Api.loginPatient(patient).then((resp) => {
            if (resp.status === 200) {
                const { accessToken } = resp.data;
                const data = parseJwt(accessToken);
                data.patients = resp.data.patients;
                const authenticatedUser = { data, accessToken };
                Auth.userLogin(authenticatedUser);
                if (!Auth.userIsAuthenticated()) {
                  showToast('error', 'Login failed, Please try again');
                  window.location.href = "/";
                } else {
                    window.location.href = "/";
                } 
            } else {
                showToast('error','Login failed, Please try again')
            }
            setIsLoginLoading(false);
        }).catch((e) => {
            setIsLoginLoading(false);
            showToast('error',e);
        });
    }
    return (
        <>{!showMrnSearch ? <>
            {
                patients.length < 2 ?
                    <div className="otp-login-container">
                        <div className="image-container">
                            <img src={enterOtpBg} alt="login-bg" />
                        </div>
                        <div className="text-container">
                            <div className="main-text">Enter Verification Code</div>
                            <div className="sub-text">A 6 digit verification code has been sent to you mobile number</div>
                        </div>
                        <div className="bottom-container">
                            <div className="form-container">
                                <OTPField value={otp} onChange={setOtp} />
                            </div>
                            <div className="form-container">
                                <PrimaryButton label="Verify" isLoading={verifying} onClick={checkOTP} />
                            </div>
                            <div style={{ textAlign: 'center' }}>
                                {!otpExpired ? (
                                    <span className="otp-expire-counter">
                                        OTP expires in <Counter seconds={props.countTo} onFinished={() => setOtpExpired(true)} /> s
                                    </span>
                                ) : (
                                    <span className="otp-expire-counter">OTP expired</span>
                                )}
                            </div>
                            <div className="retry-text">
                                <div>Did’nt receive verification code? <span onClick={props.retry}>Retry</span></div>
                            </div>
                        </div>
                        <div className="logo-container">
                            {getLogo()}
                        </div>
                    </div > :
                    <PatientSelection isLoading={isLoginLoading} patients={patients} onSelect={loginSelectedPatient} />
            }</> :
            <MRNSearch mobile={props.mobile} responseData={responseData}/>
        }
        </>
    )
}
export default OTPEnter;